import { render, staticRenderFns } from "./inner-url-redirect.vue?vue&type=template&id=2cdef5f8"
import script from "./inner-url-redirect.vue?vue&type=script&lang=ts"
export * from "./inner-url-redirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports